import { ApiProperty } from "@nestjs/swagger";
import { IsOptional } from "class-validator";
import { CodeListMainItemsDTO } from "./code-list-main-items.dto";



export class CodeListMainDTO {
    @ApiProperty()
    codeListMainId: number
    @ApiProperty()
    saleOrderId: number
    @ApiProperty() 
    totalCartons: number
    @ApiProperty()
    issuedBy: string
    @ApiProperty()
    verifiedBy: string
    @ApiProperty()
    createdAt: Date
    @ApiProperty()
    createdUser: string | null
    @ApiProperty()
    updatedAt: Date
    @ApiProperty()
    updatedUser: string | null
    @ApiProperty()
    versionFlag: number;
    @ApiProperty()
    isActive:boolean;
    @ApiProperty({type:[CodeListMainItemsDTO]})
    codeListItems:CodeListMainItemsDTO[];
    @ApiProperty()
    @IsOptional()
    isUpdate?:boolean
    @ApiProperty()
    @IsOptional()
    remarks?:string

  
}